import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('oaa_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response && err.response.status === 401) {
      localStorage.removeItem('oaa_token');
      localStorage.removeItem('oaa_user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

// Increase default timeout for slow MySQL queries
api.defaults.timeout = 120000;

export const authApi = {
  login: (email, password) => api.post('/auth/login', { email, password }),
};

export const dataApi = {
  getCacheStatus: () => api.get('/cache-status'),
  getTopAccounts: () => api.get('/top-accounts'),
  getVerticals: () => api.get('/verticals'),
  getAudienceIntelligence: (vertical, timeframe) =>
    api.get('/audience-intelligence', { params: { vertical, timeframe } }),
  getTopics: (vertical, timeframe) =>
    api.get('/audience-intelligence/topics', { params: { vertical, timeframe } }),
  getContent: (vertical, timeframe, page, sort_by, sort_order) =>
    api.get('/audience-intelligence/content', { params: { vertical, timeframe, page, sort_by, sort_order } }),
  getBrands: (vertical, timeframe) =>
    api.get('/audience-intelligence/brands', { params: { vertical, timeframe } }),
  getAudience: (vertical, timeframe, segment) =>
    api.get('/audience-intelligence/audience', { params: { vertical, timeframe, segment } }),
  getInsights: (vertical) =>
    api.get('/audience-intelligence/insights', { params: { vertical } }),
  getPriorityAccounts: (params) => api.get('/priority-accounts', { params }),
  getAccountDetail: (companyName) => api.get(`/accounts/${encodeURIComponent(companyName)}`),
  getCampaigns: (params) => api.get('/campaigns', { params }),
  getLeads: (params) => api.get('/leads', { params }),
  updateLead: (id, data) => api.put(`/leads/${id}`, data),
  getAnalytics: (timeframe) => api.get('/analytics', { params: { timeframe } }),
  getSellers: () => api.get('/sellers'),
};

export default api;
